/**
 * Session reducer for custom Scratch Clone auth.
 * Provides session state compatible with scratch-gui's expected format:
 *   state.session.session.user.username
 *   state.session.session.user.token
 *   state.session.session.user.thumbnailUrl
 *   state.session.permissions.educator
 *   state.session.permissions.student
 */

const SET_SESSION = 'scratch-gui/session/SET_SESSION';
const CLEAR_SESSION = 'scratch-gui/session/CLEAR_SESSION';

const initialState = {};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_SESSION:
        return {
            session: {
                user: {
                    id: action.user.id,
                    username: action.user.username,
                    role: action.user.role || 'student',
                    token: action.user.token || '',
                    thumbnailUrl: action.user.avatarUrl || null,
                    classroomId: '',
                    banned: false
                }
            },
            permissions: {
                educator: action.user.role === 'teacher',
                student: action.user.role === 'student',
                admin: action.user.role === 'admin'
            }
        };
    case CLEAR_SESSION:
        return {};
    default:
        return state;
    }
};

// Action creators
const setSession = user => ({
    type: SET_SESSION,
    user
});

const clearSession = () => ({
    type: CLEAR_SESSION
});

export {
    reducer as default,
    initialState as sessionInitialState,
    setSession,
    clearSession
};
